export default __webpack_public_path__ + "images/ee4c23adcc0f31e24fdef72829dcaf09-exercise.jpg";